import { useEffect, useMemo, useState } from 'react'
import { fetchThreatDownEndpointDetections } from '@/api/threatdown'
import { buildDetectionColumns } from '@/components/threatdown/detectionTableUtils'
import { SortableTable } from '@/components/SortableTable'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

export function ThreatDownDetectionsCard({ endpointId }) {
  const [detections, setDetections] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!endpointId) return
    setLoading(true)
    setError('')
    fetchThreatDownEndpointDetections(endpointId, {
      page: 1,
      page_size: 200,
      sort_by: 'scanned_at',
      sort_dir: 'desc',
    })
      .then((data) => setDetections(data.items ?? []))
      .catch(() => setError('Could not load detections.'))
      .finally(() => setLoading(false))
  }, [endpointId])

  const columns = useMemo(() => buildDetectionColumns(), [])

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Detections</CardTitle>
        {!loading && !error && (
          <p className="text-sm text-muted-foreground">
            {detections.length
              ? `${detections.length} event${detections.length === 1 ? '' : 's'} in the last 90 days`
              : 'No detections in the last 90 days'}
          </p>
        )}
      </CardHeader>
      <CardContent>
        {error ? (
          <p className="text-sm text-destructive">{error}</p>
        ) : (
          <SortableTable
            columns={columns}
            data={detections}
            defaultSort={{ id: 'scanned_at', dir: 'desc' }}
            empty="No detections recorded for this endpoint in the last 90 days."
            loading={loading}
            scrollable
          />
        )}
      </CardContent>
    </Card>
  )
}
